<script>
	export let selectedTab;
	export let tabs = ["Leads", "Ignored", "Disputed"];
	export let id = "tabs-scroll-container";

	const bgClass = "transition-all ease-in-out duration-200";
	// const tabClass = 'tab tab-md sm:tab-lg text-2xl';
	const tabClass = "tab tab-lg text-xl";
	// const tabClass = 'tab tab-lg';

	const borderBottom = "border-b-2";
	const borderTop = "border-t-2 rounded-t-lg";
	const borderLeft = "border-l-2";
	const borderRight = "border-r-2";

	const setActiveTab = (e) => {
		if (e.target.closest("button").getAttribute("disabled")) {
			return;
		}
		selectedTab = e.target.closest("button").getAttribute("tabId");
	};
</script>

<div class="scroll-mt-32" {id}>
	<nav class="flex overflow-auto">
		<div class={`border-primary ${borderBottom} w-4 border-collapse`}></div>
		<div class="block flex-none border-collapse">
			<nav class="tabs">
				{#each tabs as tab}
					<button
						disabled={tab.disabled}
						class={`font-semibold border-base-100 bg-primary text-primary-content border-b-0 ${borderTop} ${borderLeft} ${borderRight} ${tabClass} ${bgClass} ${
							(tab.id || tab) === selectedTab
								? ` tab-active !text-primary-content !border-primary`
								: ` ${borderBottom} !text-primary-content`
						} ${tab.class || ""}`}
						label={tab.label || tab.id || tab}
						tabId={tab.id}
						on:click|preventDefault={setActiveTab}
					>
						{tab.label || tab.id || tab}
					</button>
				{/each}
			</nav>
		</div>
		<div
			class={`border-primary ${borderBottom} w-full border-collapse`}
		></div>
	</nav>
</div>
